import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { RouteUrls } from "routing/routing.constants";

interface Metadata {
  title: string;
  description: string;
}

const DEFAULT_METADATA: Metadata = {
  title: "Neuroborn Cats: Play and Earn MMO Game",
  description:
    "Free 18+ browser game in cat cyberpunk alternative universe on WAX blockchain",
};

const PAGE_METADATA: Record<string, Metadata> = {
  [RouteUrls.ROOT_URL]: {
    title: "Neuroborn Cats — Free 18+ Cat Cyberpunk MMO",
    description:
      "Explore Neuroborn Cats, a free 18+ browser MMO set in a dark cat cyberpunk world. Discover Gatia, its factions, and player-owned NFTs on WAX.",
  },
  [RouteUrls.FOR_INFLUENCERS_URL]: {
    title: "For Creators & Influencers — Neuroborn Cats",
    description:
      "Create content about Neuroborn Cats, an 18+ cat cyberpunk MMO. Explore our press kit, brand assets, creator perks, and collaboration opportunities.",
  },
  [RouteUrls.WAX_WALLET_URL]: {
    title: "Free WAX Wallet Activation Guide — Neuroborn Cats",
    description:
      "Stuck on the final step of creating your WAX wallet? Learn how to bypass the 5 WAX activation fee and get your MyCloudWallet activated for free.",
  },
};

export const PageMeta = () => {
  const { pathname } = useLocation();
  const path = pathname.replace(/\/+$/, "") || RouteUrls.ROOT_URL;
  const { title, description } = PAGE_METADATA[path] || DEFAULT_METADATA;

  useEffect(() => {
    document.title = title;

    let meta = document.head.querySelector<HTMLMetaElement>(
      'meta[name="description"]'
    );
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, [title, description]);

  return null;
};
